import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import { Show } from '@clerk/react';

import AppLayout from './layouts/AppLayout';
import DocFeedback from './pages/DocFeedback';
import Home from './pages/Home';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import ReviewQueue from './pages/ReviewQueue';
import Settings from './pages/Settings';
import Signup from './pages/Signup';
import Tickets from './pages/Tickets';

function ProtectedLayout() {
  return (
    <Show when="signed-in" fallback={<Navigate to="/login" replace />}>
      <AppLayout />
    </Show>
  );
}

function ProtectedOnboarding() {
  return (
    <Show when="signed-in" fallback={<Navigate to="/login" replace />}>
      <Onboarding />
    </Show>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/onboarding" element={<ProtectedOnboarding />} />

        <Route element={<ProtectedLayout />}>
          <Route path="/home" element={<Home />} />
          <Route path="/review-queue" element={<ReviewQueue />} />
          <Route path="/tickets" element={<Tickets />} />
          <Route path="/doc-feedback" element={<DocFeedback />} />
          <Route path="/settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;